<template>
	<div>
		<div class="bgCol sixth">
			<el-form :model="form" :rules="rule" ref="form">
			<div class="item">
				<span class="label">任务完成状态:</span>
				<div class="input"  v-if="is_edit===true">
					<el-form-item label="" prop="task_complete_status">
					<el-radio-group v-model="form.task_complete_status">
						<el-radio :label="1">任务完成</el-radio>
						<el-radio :label="2">任务取消</el-radio>
					</el-radio-group>
					</el-form-item>
				</div>
				<div class="input"  v-if="is_edit===false">
					<span v-if="form.task_complete_status==1" style="color: white;">任务完成</span>
					<span v-if="form.task_complete_status==2" style="color: white;">任务取消</span>
				</div>
			</div>
			<div class="item">
				<span class="label"  v-if="is_edit===true">任务备注说明:</span>
				<span class="label"  v-else>任务备注说明:{{form.content}}</span>
			</div>
			<el-form-item label="" prop="content"  v-if="is_edit===true">
			<el-input class="explain" type="textarea" :autosize="{ minRows: 4}" v-model="form.content"
				placeholder="请输入详细说明"></el-input>
				</el-form-item>	
			<div class="item" v-if="is_weather==1">
					<span class="label">任务执行期间天气:</span>
				</div>
				
				<div class="climate_box" v-if="is_weather==1">
				   <div class="climate_item" v-for="(item,index) in weatherList" :class="{'active':index==10}" >
				       <div class="num">{{item.date}}</div>
				       <div class="degrees">{{item.min_temp}}℃-{{item.max_temp}}℃</div>
				       <div class="state">{{item.weather}}</div>
				       <div class="windSpeed">{{item.wind_direction}}</div>
				       <!--<div class="quality">{{item.quality}}</div> -->
				   </div>
				</div>
		</el-form>
		</div>
		
	</div>
</template>

<script>
import {getTaskWeatherList} from '@/api/step'
		export default {
			name: "Last",
	
			props: {
				task_complete_status: {
					type: Number,
					default: 0
				},
				content: {
					type: String,
					default: 0
				},
				work_task_id:{
					type: Number,
					default: 0
				},
				is_weather:{
					type: Number,
					default: 0
				},
				is_edit:{
					type:Boolean,
					default:true
				}
				
			},
			data() {
				return {

                       
						 form: {
						 	task_complete_status:this.task_complete_status,
						 	content: this.content,
						 },
						 weatherList:[],
						 rule: {
						 	task_complete_status: [{
						 		required: true,
						 		message: '必选',
						 		trigger: 'change'
						 	}],
						 	content: [{
						 		required: true,
						 		message: '必填',
						 		trigger: 'blur'
						 	}],
						 },
				}
				
				},
				created() {
					 this.form.task_complete_status=this.task_complete_status
					 this.get_task_weather_list(this.work_task_id)
				},
					methods: {
						get_task_weather_list(){
							getTaskWeatherList(this.work_task_id).then(res=>{
								if(res.length==0){
									this.$parent.is_weather=0
								}
								
								this.weatherList=res
							})
						},
						validateForm () {
						    let flag = null
						    this.$refs['form'].validate(valid => {
						     if (valid) {
						      flag = true
						     } else {
						      flag = false
						     }
						    })
						    return flag
						   }
						
					}
				
			}
		

</script>

<style scoped lang="less">
	
.climate_box{
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 20px;
                    .climate_item{
                        margin-right: 1px;
                        margin-bottom: 1px;
                        background: rgba(212, 249, 255, 0.11);
                        width: 255px;
                        height: 186px;
                        color: #fff;
                        text-align: center;
                        font-size: 16px;
                
                        .num{
                            padding: 18px 0 0 21px;
                            text-align: left;
                            font-size: 18px;
                        }
                        .degrees{
                            padding-top: 15px;
                        }
                        .state{
                            padding-top: 15px;
                        }
                        .windSpeed{
                            padding-top: 5px;
                        }
                        .quality{
                            display: inline-block;
                            margin-top: 15px;
                            padding: 1px 23px;
                            background-color: #00A1E6;
                            border-radius: 11px;
                            font-size: 14px;
                        }
                    }
                  
}
</style>
